import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from '../shared/Dropdown';
import { useSelector } from 'react-redux';
import { Spinner, SpinnerSize } from '@fluentui/react';
import './FolderBreadcrumbs.scss';


const splitPaths = (path, foldersMap) => {
  const paths = [];

  path.split('/').forEach((splitPath) => {
    if (splitPath === '') {
      paths.push('');
      return;
    }
    const priorPath = paths[paths.length - 1];
    if (priorPath) {
      if (foldersMap[priorPath]) {
        paths.push([priorPath, splitPath].join('/'));
      } else {
        paths[paths.length - 1] = [priorPath, splitPath].join('/');
      }
    } else {
      paths.push('');
      paths.push(splitPath);
    }
  });
  return paths;
};

const handleNavigate = (subPath, isLastIndex, callback) => {
  if (!isLastIndex) {
    callback(subPath);
  }
};

const getClass = (isLastIndex) => isLastIndex ? 'breadcrumb-inactive' : 'breadcrumb-active';

const divider = (<span className='breadcrumb-divider'>{'>'}</span>);

const getDivider = (isLastIndex) => {
  if (!isLastIndex) {
    return divider;
  }
};

const getBreadcrumb = (subPath, isLastIndex, foldersMap, callback) => (
  <div key={subPath} >
    <span className={getClass(isLastIndex)}
      onClick={() => {
        handleNavigate(subPath, isLastIndex, callback);
      }}>{
        foldersMap[subPath]?.name
      }
    </span>
    {
      getDivider(isLastIndex)
    }
  </div>
);

const getBreadcrumbWithEllipse = (paths, foldersmap, callback) => {
  const breadcrumbs = [];
  breadcrumbs.push(getBreadcrumb(paths[0], false, foldersmap, callback));
  const dropdownOptions = paths.slice(1, -1).map((path) => ({ value: path, label: foldersmap[path].name }));
  const lastIndex = paths.length - 1;
  breadcrumbs.push(<Dropdown key={`${paths[lastIndex]}dropdown`} dropdownOptions={dropdownOptions} callback={callback} id='breadcrumb-ellips-dropdown'/>);
  breadcrumbs.push(divider);
  breadcrumbs.push(getBreadcrumb(paths[lastIndex], true, foldersmap, callback));
  return breadcrumbs;
};

export const FolderBreadcrumbs = ({ path, updateBrowsingFolderCallback, folderMap, selectedRecord, isSearchingFiles }) => {
  const isLoading = useSelector((state) => state.app.isLoading);
  const paths = splitPaths(path, folderMap);
  const lastIndex = paths.length - 1;
  const breadcrumbs = paths.length > 2 ? getBreadcrumbWithEllipse(paths, folderMap, updateBrowsingFolderCallback) :
                                    paths.map((subPath, index) => getBreadcrumb(subPath, index === lastIndex, folderMap, updateBrowsingFolderCallback));

  return (
    <div className={'breadcrumb-container'}>
      { breadcrumbs }
      { (!(selectedRecord.fetchedFiles || isLoading) && isSearchingFiles) && <Spinner size={SpinnerSize.xSmall} style={{ marginLeft: '4px', marginTop: '2px' }} /> }
    </div>
  );
};

FolderBreadcrumbs.propTypes = {
  path: PropTypes.string,
  updateBrowsingFolderCallback: PropTypes.func,
  folderMap: PropTypes.object,
  selectedRecord: PropTypes.object,
  isSearchingFiles: PropTypes.bool,
};
